import React, { useState } from "react";
import classNames from "classnames";
import useStateWithCallback from 'use-state-with-callback';

import connectProps from "fantastic/lib/connectProps";
import ColumnTool from "./ColumnTool";
//import Drag from "./Drag";

const ColumnsToolsBlock = ( { onCollapsed, theme: { style_attributes } } ) => {
  const [collapsed, setCollapsed] = useStateWithCallback(true, onCollapsed);

  const toggleCollapsed = () => setCollapsed(!collapsed);
  const togglerText = collapsed ? i18n.t('show_all', { count: 6 }) : i18n.t('hide');
  const styles = {
    maxHeight: collapsed ? "98px" : "190px"
  };

  const renderSection = (section, index) => {
    return (
      <ColumnTool
        id={index}
        key={index}
        data={section}
        number={section.contents.length}
        itemType="SECTION/NEW"
        meta={{ type: "SECTION/NEW" }}
      />
    );
  };

  const initialValues = {
    background: 'transparent',
    background_repeat: 'repeat',
    background_image: 'none',
    background_position: 'center top',
    meta: { type: "SECTION" },
    show: ''
  };

  const columnGutter = `${parseInt(style_attributes["column-gutter"] || '0')}`;

  const sections = [
    {
      contents: [{ column: "twelve", items: [] }]
    },
    {
      contents: [{ column: "six", items: [] }, { column: "six", items: [] }]
    },
    {
      contents: [{ column: "four", items: [] }, { column: "four", items: [] }, { column: "four", items: [] }]
    },
    {
      contents: [
        { column: "three", items: [] },
        { column: "three", items: [] },
        { column: "three", items: [] },
        { column: "three", items: [] }
      ]
    },
    {
      contents: [
        { column: "three", items: [] },
        { column: "two", items: [] },
        { column: "two", items: [] },
        { column: "two", items: [] },
        { column: "three", items: [] }
      ]
    },
    {
      contents: [
        { column: "two", items: [] },
        { column: "two", items: [] },
        { column: "two", items: [] },
        { column: "two", items: [] },
        { column: "two", items: [] },
        { column: "two", items: [] }
      ]
    }
  ].map(section => {
    const paddings = section["contents"].length > 1 ? { css_padding_left: columnGutter, css_padding_right: columnGutter } : {};

    return { ...section, ...initialValues, ...paddings };
  });

  return (
    <div className="fantastic-tools-block">
      <div className="fantastic-tools-block__header">
        <div className="fantastic-tools-block__caption">{ i18n.t('columns') }</div>
        <a onClick={() => toggleCollapsed()}>{togglerText}</a>
      </div>
      <div style={styles} className="fantastic-tools-block__body fantastic-tools-block__body--collapsable">
        {sections.map(renderSection)}
      </div>
    </div>
  );
};

export default connectProps("theme")(ColumnsToolsBlock);
